<div class="modal-header">
  <h4 class="modal-title">Password Reset</h4>
  <button
    type="button"
    class="btn-close text-danger"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  ></button>
</div>
<div class="modal-body container p-4">
  <form *ngIf="!TimeForCode" class="mt-1" [formGroup]="loginForm">
    <p>Enter the email associated with your account below.</p>
    <div class="row">
      <div class="col-8">
        <div class="form-group mb-3">
          <label for="loginUsername"><b>Email Address</b></label>
          <input
            type="text"
            formControlName="loginUsername"
            class="form-control"
            placeholder="Email Address..."
            autocomplete="username"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col text-end">
        <button
          class="btn btn-secondary me-2"
          (click)="activeModal.dismiss('Cross click')"
        >
          Cancel
        </button>
        <button
          class="btn btn-success"
          [disabled]="loginForm.invalid"
          (click)="onSubmit()"
        >
          Submit
        </button>
      </div>
    </div>
  </form>
  <form
    *ngIf="TimeForCode"
    class="needs-validation"
    [formGroup]="resetForm"
    autocomplete="off"
  >
    <div class="row">
      <div class="col-md-12">
        <div class="alert alert-info">
          If the email you entered is correct, a code will be emailed to you.
          Please enter that code below to reset your password.
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="form-group mb-3">
          <label>Code</label>
          <input
            formControlName="code"
            type="text"
            class="form-control"
            role="presentation"
            autocomplete="new-password"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="form-group mb-3">
          <label>Password</label>
          <div class="input-group">
            <input
              autocomplete="new-password"
              [type]="isPasswordVisible ? 'text' : 'password'"
              class="form-control"
              formControlName="password"
              (input)="onPasswordChange()"
            />
            <div class="input-group-append">
              <button
                class="btn btn-light"
                type="button"
                (click)="togglePasswordVisibility()"
              >
                <i
                  class="fa"
                  [class.fa-eye]="!isPasswordVisible"
                  [class.fa-eye-slash]="isPasswordVisible"
                ></i>
              </button>
            </div>
          </div>
          <div class="error-message" *ngIf="!isPasswordValid">
            <div *ngFor="let error of getPasswordErrors()">{{ error }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="form-group mb-3">
          <label>Confirm Password</label>
          <div class="input-group">
            <input
              [type]="isConfirmVisible ? 'text' : 'password'"
              class="form-control"
              autocomplete="new-password"
              (input)="onConfirmChange()"
              formControlName="confirmPassword"
            />
            <div class="input-group-append">
              <button
                class="btn btn-light"
                type="button"
                (click)="toggleConfirmVisibility()"
              >
                <i
                  class="fa"
                  [class.fa-eye]="!isConfirmVisible"
                  [class.fa-eye-slash]="isConfirmVisible"
                ></i>
              </button>
            </div>
          </div>
          <div class="error-message" *ngIf="!isConfirmValid">
            <div *ngFor="let error of getMatchingError()">{{ error }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 text-end">
        <button class="btn btn-secondary me-2" (click)="onCancel()">
          Cancel
        </button>
        <button
          type="submit"
          class="btn btn-success"
          [disabled]="resetForm.invalid || passwordErrors.length > 0"
          (click)="onSubmitReset()"
        >
          Reset Password
        </button>
        <div *ngIf="reset_error != ''" class="alert alert-danger">
          {{ reset_error }}
        </div>
      </div>
    </div>
  </form>
</div>
